import CheckoutNextSteps from '~/themes/oknadverenamiru/components/cart/CheckoutNextSteps'
import ContactBox from '~/themes/oknadverenamiru/components/shop/ContactBox'
import FileBox from '~/themes/oknadverenamiru/components/content/FileBox'
import PageFiles from '~/themes/base/components/content/PageFiles'
import PageIntro from '~/themes/oknadverenamiru/components/shop/PageIntro'

export default {
  extends: PageFiles,
  components: {
    CheckoutNextSteps,
    FileBox,
    PageIntro,
    ContactBox,
  },
  computed: {
    fileList() {
      return this.files.map(file => {
        let path = ''
        if (Array.isArray(file.file)) {
          path = file.file[0] && file.file[0].path
        } else {
          path = ''
        }
        return {
          title: file.title,
          path,
        }
      })
    },
  },
  props: {
    files: {
      type: Array,
    },
  },
}
